/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface CoordinatesProps {
  latitude: number | null;
  longitude: number | null;
}

export class CoordinatesRecord extends Record<CoordinatesProps>({
  latitude: null as any,
  longitude: null as any,
}) {
  public static fromJS(json: {
    latitude: number | null;
    longitude: number | null;
  }): CoordinatesRecord {
    if (json == null) {
      throw new Error('CoordinatesRecord.fromJS: parameter cannot be null');
    }
    return new CoordinatesRecord({
      latitude: json.latitude,
      longitude: json.longitude,
    });
  }

  public static fromJSUnsafe(json: {
    latitude: number | null;
    longitude: number | null;
  }): [CoordinatesRecord, Error[]] {
    if (json == null) {
      throw new Error('CoordinatesRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new CoordinatesRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      latitude: tryOrDefault(
        () => json.latitude,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      longitude: tryOrDefault(
        () => json.longitude,
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: CoordinatesProps) {
    super(props);
    if (props == null) {
      throw new Error('CoordinatesRecord constructor parameter cannot be null');
    }
  }
}

export abstract class CoordinatesViewModelBase implements CoordinatesProps {
  protected readonly _props: CoordinatesProps;
  private _json?: CoordinatesProps;

  get latitude(): number | null {
    return this._props.latitude;
  }
  get longitude(): number | null {
    return this._props.longitude;
  }

  constructor(props: CoordinatesProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        latitude: this._props.latitude,
        longitude: this._props.longitude,
      };
    }
    return this._json;
  }
}
